export default __webpack_public_path__ + "static/media/logo.630460af.svg";